import { AfterViewInit, Component, Input } from '@angular/core';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { DataSourceCustomAction } from '@m4u-angular/base/datalayer/BaseDataSources';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { BaseEntitiesResponse, BaseState, GenericListEntity, NotificationListParams } from '@m4u-angular/base/entities/BaseEntities';
import { NotificationEndpoint } from '@m4u-angular/core/endpoints/notification.endpoint';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { EnumNotificationDeliveryOptions } from '@m4u-angular/core/framework/sysenums.enum';

export class State extends BaseState {
    Templates: GenericListEntity[] = [];
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-notification-dispatch-notifications',
    templateUrl: './notification-dispatch-notifications.component.html',
})
export class NotificationDispatchNotificationsComponent extends BaseComponent<State> implements AfterViewInit {
    @Input() NotificationDispatchID: number;
    @Input() NotificationDispatchDeliveryMethod: EnumNotificationDeliveryOptions;

    constructor(A: ServiceBagService,
        private notificationEndpoint: NotificationEndpoint) {
        super(A, 'NotificationDispatchNotificationsComponent', State);
    }

    override ngAfterViewInit() {
        this.Do(this.notificationEndpoint.GetNotificationsTemplates(), false, (response: BaseEntitiesResponse<GenericListEntity>) => {
            this.State.Templates = response.Entities;
        });
        
        const params = new NotificationListParams();
        params.NotificationDispatchID = this.NotificationDispatchID;

        this.DataSources['Notifications'] =
            new DataSourceCustomAction((options: DataLoadOptions) => this.notificationEndpoint.GetNotificationsReport(params, options),
                undefined, undefined, false);
    }
}